module.exports = __webpack_public_path__ + "static/media/shredder.e739032e.svg";